if (!customElements.get('leny-product-gallery')) {
  class LenyProductGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Initialize all functionality after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.initOpenModal();
        this.initCloseModal();
        this.initSmoothScroll();
      }, 100);

      document.addEventListener('variant:changed', () => {
        this.initOpenModal();
        this.initCloseModal();
        this.initSmoothScroll();
      });
    }

    initOpenModal() {
      const mainImages = document.querySelectorAll('.main-image');
      const modal = document.getElementById('image-modal');

      mainImages.forEach((image, index) => {
        image.addEventListener('click', () => {
          this.showAllImages();
          modal.style.display = 'block';
          document.body.classList.add('no-scroll');
        });
      });
    }

    showAllImages() {
      const modal = document.getElementById('image-modal');
      const mainImages = document.querySelectorAll('.main-image');
      const modalContent = modal.querySelector('.modal-content');

      // Clear existing content
      modalContent.innerHTML = '';

      // Create thumbnails container
      const thumbnailsContainer = document.createElement('div');
      thumbnailsContainer.classList.add('modal-thumbnails');
      modalContent.appendChild(thumbnailsContainer);

      // Add all images and thumbnails
      mainImages.forEach((image, index) => {
        // Create main image
        const modalImage = document.createElement('img');
        modalImage.src = image.src;
        modalImage.classList.add('modal-image');
        modalImage.id = `modal-image-${index}`;
        modalContent.appendChild(modalImage);

        // Create thumbnail
        const thumbnail = document.createElement('img');
        thumbnail.src = image.src;
        thumbnail.classList.add('modal-thumbnail');
        thumbnail.addEventListener('click', () => {
          document.getElementById(`modal-image-${index}`).scrollIntoView({ behavior: 'smooth' });
        });
        thumbnailsContainer.appendChild(thumbnail);
      });
    }

    initCloseModal() {
      // Get all close modal buttons in the document
      const closeButtons = document.querySelectorAll('.close-modal');
      const desktopModal = document.getElementById('image-modal');
      
      // Add click handlers to all close buttons
      closeButtons.forEach(button => {
        // Remove any existing event listeners
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        // Add new event listener
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Find the closest modal to this button
          const parentModal = newButton.closest('.image-modal');
          if (parentModal) {
            parentModal.style.display = 'none';
            document.body.classList.remove('no-scroll');
          }
        });
      });

      // Close when clicking outside the image
      if (desktopModal) {
        desktopModal.addEventListener('click', (e) => {
          if (e.target === desktopModal) {
            desktopModal.style.display = 'none';
            document.body.classList.remove('no-scroll');
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (desktopModal && desktopModal.style.display === 'block' && e.key === 'Escape') {
          desktopModal.style.display = 'none';
          document.body.classList.remove('no-scroll');
        }
      });
    }

    initSmoothScroll() {
      const thumbnailLinks = document.querySelectorAll('.thumbnail-link');
      thumbnailLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    }
  }

  customElements.define('leny-product-gallery', LenyProductGallery);
}

if (!customElements.get('leny-product-gallery-mobile')) {
  class LenyProductGalleryMobile extends HTMLElement {
    constructor() {
      super();
      this.splide = null;
    }

    connectedCallback() {
      this.initSplide();
      this.initOpenModal();
      this.initCloseModal();

      // Store the current media ID to detect actual media changes
      this.currentMediaId = null;
      
      document.addEventListener('variant:changed', (event) => {
        // Get all product variants data elements to check if media has changed
        const variantDataElements = document.querySelectorAll('[data-variant-inventory]');
        let mediaChanged = false;
        
        // Check if we need to update the gallery (only if media has changed)
        const productInfo = document.querySelector('product-info');
        if (productInfo) {
          // Try to find the selected variant
          const selectedVariant = productInfo.querySelector('variant-selects [data-selected-variant]');
          if (selectedVariant) {
            try {
              const variantData = JSON.parse(selectedVariant.innerHTML);
              // Only reload gallery if the featured media has changed
              const newMediaId = variantData.featured_media ? variantData.featured_media.id : null;
              mediaChanged = newMediaId !== this.currentMediaId && newMediaId !== null;
              this.currentMediaId = newMediaId;
            } catch (e) {
              // If we can't parse the variant data, default to not reloading
              mediaChanged = false;
            }
          }
        }
        
        // Only reinitialize if the media has actually changed
        if (mediaChanged) {
          if (this.splide) {
            this.splide.destroy();
          }
          this.initSplide();
          this.initOpenModal();
          this.initCloseModal();
        }
      });
    }

    initSplide() {
      // Wait for Splide to be loaded
      const checkSplide = setInterval(() => {
        if (window.Splide) {
          clearInterval(checkSplide);
          
          this.splide = new Splide('#leny-product-gallery-mobile', {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            gap: '1rem',
            pagination: true,
            arrows: false,
            drag: true,
            snap: true,
            autoHeight: true,
            breakpoints: {
              749: {
                perPage: 1,
                gap: '0.5rem',
                pagination: true
              }
            }
          });
          
          this.splide.mount();
        }
      }, 100);
    }

    initOpenModal() {
      const mobileImages = this.querySelectorAll('.mobile-slide-image');
      const modal = document.getElementById('mobile-image-modal');

      mobileImages.forEach((image, index) => {
        image.addEventListener('click', () => {
          this.showAllImages();
          modal.style.display = 'block';
          document.body.classList.add('no-scroll');
        });
      });
    }

    showAllImages() {
      const modal = document.getElementById('mobile-image-modal');
      const mobileImages = this.querySelectorAll('.mobile-slide-image');
      const modalContent = modal.querySelector('.modal-content');

      // Clear existing content
      modalContent.innerHTML = '';

      // Create thumbnails container
      const thumbnailsContainer = document.createElement('div');
      thumbnailsContainer.classList.add('modal-thumbnails');
      modalContent.appendChild(thumbnailsContainer);

      // Add all images and thumbnails
      mobileImages.forEach((image, index) => {
        // Create main image
        const modalImage = document.createElement('img');
        modalImage.src = image.src;
        modalImage.classList.add('modal-image');
        modalImage.id = `mobile-modal-image-${index}`;
        modalContent.appendChild(modalImage);

        // Create thumbnail
        const thumbnail = document.createElement('img');
        thumbnail.src = image.src;
        thumbnail.classList.add('modal-thumbnail');
        thumbnail.addEventListener('click', () => {
          document.getElementById(`mobile-modal-image-${index}`).scrollIntoView({ behavior: 'smooth' });
        });
        thumbnailsContainer.appendChild(thumbnail);
      });
    }

    initCloseModal() {
      const modal = document.getElementById('mobile-image-modal');

      if (modal) {
        // Close when clicking outside the image
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.style.display = 'none';
            document.body.classList.remove('no-scroll');
          }
        });

        // Close on escape key
        document.addEventListener('keydown', (e) => {
          if (modal.style.display === 'block' && e.key === 'Escape') {
            modal.style.display = 'none';
            document.body.classList.remove('no-scroll');
          }
        });
      }
    }
  }

  customElements.define('leny-product-gallery-mobile', LenyProductGalleryMobile);
}
